import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import api from '@/api';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'OperationSettingsEdit',
  data: function data() {
    return {
      operationSettingsAreTypeEnums: [],
      citys: [],
      title: '',
      form: {
        settingsId: null,
        areOneId: null,
        areTwoId: null,
        areThreeId: null,
        areType: '',
        freeExperience: null,
        offlineActivities: null,
        openTime: null,
        createTime: null,
        maleNum: null,
        femaleNum: null,
        selectCitys: [],
        firstChargeDiscount: null,
        femaleSwitch: 0,
        maleSwitch: 0
      },
      rules: {
        femaleSwitch: [{
          required: true,
          message: '请勾选女性会员体验',
          trigger: 'blur'
        }],
        maleSwitch: [{
          required: true,
          message: '请勾选男性会员体验',
          trigger: 'blur'
        }],
        selectCitys: [{
          required: true,
          message: '请选择区域',
          trigger: 'blur'
        }],
        freeExperience: [{
          required: true,
          message: '请输入免费体验',
          trigger: 'blur'
        }],
        offlineActivities: [{
          required: true,
          message: '请输入线下活动',
          trigger: 'blur'
        }],
        openTime: [{
          required: true,
          message: '请输入开通日期',
          trigger: 'blur'
        }],
        createTime: [{
          required: true,
          message: '请输入创建时间',
          trigger: 'blur'
        }],
        maleNum: [{
          required: true,
          message: '请输入男限制数',
          trigger: 'blur'
        }],
        femaleNum: [{
          required: true,
          message: '请输入女限制数',
          trigger: 'blur'
        }],
        firstChargeDiscount: [{
          required: true,
          message: '请选择首冲优惠',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    initCitys: function initCitys() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return api.GET_BYCITYOPENING_TREE_LIST({
                plag: '1'
              });
            case 1:
              res = _context.v;
              _this.citys = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    initEunmData: function initEunmData() {
      var thiz = this;
      this.enums.getSettingsAreType(function (result) {
        thiz.operationSettingsAreTypeEnums = result.body;
      });
    },
    setTitle: function setTitle(title) {
      this.title = title;
    },
    initData: function initData() {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.initCitys();
      this.initEunmData();
      this.form.settingsId = null;
      this.form.areOneId = null;
      this.form.areTwoId = null;
      this.form.areThreeId = null;
      this.form.areType = null;
      this.form.freeExperience = null;
      this.form.offlineActivities = null;
      this.form.openTime = null;
      this.form.createTime = null;
      this.form.maleNum = null;
      this.form.femaleNum = null;
      this.form.selectCitys = null;
      this.form.firstChargeDiscount = null;
      this.form.maleSwitch = null;
      this.form.femaleSwitch = null;
    },
    setData: function setData(data) {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.initCitys();
      this.initEunmData();
      this.form.settingsId = data.settingsId + '';
      this.form.areOneId = data.areOneId + '';
      this.form.areTwoId = data.areTwoId + '';
      this.form.areThreeId = data.areThreeId + '';
      this.form.areType = data.areType;
      this.form.freeExperience = data.freeExperience;
      this.form.offlineActivities = data.offlineActivities;
      this.form.openTime = data.openTime + '';
      this.form.createTime = data.createTime + '';
      this.form.maleNum = data.maleNum + '';
      this.form.femaleNum = data.femaleNum + '';
      this.form.firstChargeDiscount = data.firstChargeDiscount;
      this.form.femaleSwitch = data.femaleSwitch;
      this.form.maleSwitch = data.maleSwitch;
      var selectCitys = [];
      selectCitys.push(data.areOneId + '');
      selectCitys.push(data.areTwoId + '');
      this.form.selectCitys = selectCitys;
    },
    updateApi: function updateApi() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return api.UPDATE_OPERATIONSETTINGS(_this2.form);
            case 1:
              _this2.$emit('initTableData');
              _this2.$message.success('操作成功');
              _this2.handleClose();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    saveApi: function saveApi() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return api.SAVE_OPERATIONSETTINGS(_this3.form);
            case 1:
              _this3.$emit('initTableData');
              _this3.$message.success('操作成功');
              _this3.handleClose();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    save: function save() {
      var _this4 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this4.form.settingsId != null) {
            _this4.$confirm('此操作将永久修改该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              _this4.updateApi();
            }).catch(function () {
              _this4.$message({
                type: 'info',
                message: '已取消修改'
              });
            });
          } else {
            _this4.saveApi();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose: function handleClose(done) {
      this.$emit('close');
    }
  }
};